<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const accountId = computed(() => route.params.accountId);

const loading = ref(false);
const error = ref('');
const results = ref([]);

const buscarCorrecoes = async () => {
  loading.value = true;
  error.value = '';
  results.value = [];

  try {
    const response = await fetch(
      'https://n8n1.artificialseller.com/webhook/ml-correcoes-anuncio',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          account_id: accountId.value,
          tipo: 'correcoes_anuncio',
        }),
      }
    );

    if (!response.ok) {
      throw new Error('Erro ao buscar relatório');
    }

    const data = await response.json();

    results.value = Array.isArray(data)
      ? data
      : data.data || [];
  } catch (e) {
    error.value = e.message || 'Erro desconhecido';
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col gap-4 p-6">
    <div>
      <h1 class="text-2xl font-semibold text-slate-900 dark:text-slate-100">
        Mercado Livre
      </h1>

      <p class="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Relatório de correções de anúncio.
      </p>

      <p class="mt-2 text-xs text-slate-500">
        Account ID: {{ accountId }}
      </p>
    </div>

    <div class="rounded-xl border border-slate-200 p-4 dark:border-slate-700">
      <button
        class="rounded bg-woot-500 px-4 py-2 text-sm font-medium text-white"
        :disabled="loading"
        @click="buscarCorrecoes"
      >
        {{ loading ? 'Buscando...' : 'Buscar Correções' }}
      </button>
    </div>

    <p
      v-if="error"
      class="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-600"
    >
      {{ error }}
    </p>

    <div class="rounded-xl border border-slate-200 dark:border-slate-700">
      <div class="border-b border-slate-200 p-4 dark:border-slate-700">
        <h2 class="text-lg font-medium text-slate-900 dark:text-slate-100">
          Correções encontradas
        </h2>
      </div>

      <div
        v-if="!loading && results.length === 0"
        class="p-4 text-sm text-slate-500"
      >
        Nenhum dado carregado.
      </div>

      <div
        v-for="item in results"
        :key="item.id || item.grupo"
        class="border-b border-slate-100 p-4 dark:border-slate-800"
      >
        <div class="font-medium text-slate-900 dark:text-slate-100">
          {{ item.grupo || item.titulo || 'Correção de anúncio' }}
        </div>

        <div class="mt-1 text-sm text-slate-600 dark:text-slate-400">
          Total: {{ item.total || 1 }}
        </div>

        <div
          v-if="item.exemplo"
          class="mt-2 text-sm text-slate-500"
        >
          {{ item.exemplo }}
        </div>
      </div>
    </div>
  </div>
</template>
